import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import BigCard from "../../../general/BigCard";
import styles from "./FabricadosL2.module.css";
import LeafletMap from "./maps/LeafletMap";
import { FabricadosStore } from "./FabricadosStore";

function FabricadosL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);

  const setFabricadosMapImage = FabricadosStore(
    (state) => state.setFabricadosMapImage
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [numeroPropriedades, areaMedia] = await Promise.all([
          Api.getNumeroPropriedades2(
            distrito,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
          ),
          Api.getAreaMediaDistrito(distrito),
        ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito]);

  return (
    <div className={styles.fabricadosL2}>
      <div className={styles.cards}>
        <div className={styles.bigcard}>
          <BigCard
            name={"Propriedades"}
            value={numeroPropriedades?.value ?? "..."}
          />
        </div>
        <div className={styles.bigcard}>
          <BigCard
            name={"Área Média"}
            value={areaMedia?.value.toFixed(2) ?? "..."}
          />
        </div>
      </div>
      <div className={styles.map}>
        <LeafletMap distrito={distrito} onImageReady={setFabricadosMapImage} />
      </div>
    </div>
  );
}

export default FabricadosL2;
